module.exports = __webpack_public_path__ + "img/evolutionary_model.6b1af2b7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evolutionary_model.gif
// module id = Kyn+
// module chunks = 0